/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Manager_Inventory_OutInputs */

const vi_dashboard_manager_inventory_out = /** @type {(inputs: Dashboard_Manager_Inventory_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hết hàng`)
};

/**

* @param {Dashboard_Manager_Inventory_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_manager_inventory_out = /** @type {((inputs?: Dashboard_Manager_Inventory_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Manager_Inventory_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_manager_inventory_out(inputs)
});